import { Zap, Award, MapPinned, ShieldCheck } from "lucide-react";

export const WhyUs = () => {
  return (
    <section
      data-testid="why-us-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
            — Pourquoi PDR France
          </div>
          <h2
            data-testid="why-us-title"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]"
          >
            4 raisons de nous<br />
            faire <span className="text-white/40">confiance</span>
          </h2>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-6 auto-rows-[220px]">
          {/* Large card - Mechanic image */}
          <div className="md:col-span-4 lg:col-span-7 row-span-2 relative overflow-hidden bg-[#111111] border border-white/5 group">
            <img
              src="https://images.pexels.com/photos/8470679/pexels-photo-8470679.jpeg"
              alt="Technicien DSP"
              className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-8 md:p-10">
              <Award className="w-10 h-10 text-[#007AFF] mb-4" strokeWidth={1.25} />
              <h3 className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight mb-3">
                Technique artisanale<br />de pointe
              </h3>
              <p className="text-sm text-white/70 max-w-md">
                Nos techniciens DSP sont formés aux outils et méthodes les plus
                innovants du secteur. Un savoir-faire rare au service de votre
                véhicule.
              </p>
            </div>
          </div>

          {/* Top right - Rapidité */}
          <div className="md:col-span-4 lg:col-span-5 bg-[#111111] border border-white/5 p-8 flex flex-col justify-between hover:border-[#007AFF]/30 transition-colors group">
            <Zap
              className="w-10 h-10 text-[#007AFF]"
              strokeWidth={1.25}
            />
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-2">
                / 01 Rapidité
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight mb-2">
                Intervention sous 48h
              </h3>
              <p className="text-sm text-white/60">
                Délais courts, atelier mobile prêt à se déplacer sur votre site.
              </p>
            </div>
          </div>

          {/* Mid - Couverture */}
          <div className="md:col-span-2 lg:col-span-5 bg-[#007AFF] p-8 flex flex-col justify-between text-white group relative overflow-hidden">
            <div className="absolute inset-0 grid-pattern opacity-30" />
            <MapPinned className="w-10 h-10 text-white relative" strokeWidth={1.25} />
            <div className="relative">
              <div className="text-xs uppercase tracking-[0.3em] text-white/70 mb-2">
                / 02 Couverture
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight mb-2">
                5 continents
              </h3>
              <p className="text-sm text-white/80">
                Intervention en France, Europe, Afrique, Amérique, Asie et Océanie.
              </p>
            </div>
          </div>

          {/* Bottom wide - Garantie */}
          <div className="md:col-span-2 lg:col-span-12 bg-[#111111] border border-white/5 p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 hover:border-[#007AFF]/30 transition-colors">
            <ShieldCheck
              className="w-12 h-12 text-[#007AFF] flex-shrink-0"
              strokeWidth={1.25}
            />
            <div className="flex-1">
              <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-2">
                / 03 Garantie & sécurité
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold uppercase tracking-tight mb-1">
                Qualité irréprochable · Garantie à vie sur nos réparations DSP
              </h3>
              <p className="text-sm text-white/60">
                Aucune altération de la peinture d'origine, préservation totale
                des protections d'usine et de la valeur de votre véhicule.
              </p>
            </div>
            <a
              href="#contact"
              className="border border-white/20 hover:border-[#007AFF] hover:text-[#007AFF] px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors whitespace-nowrap"
              data-testid="why-us-cta"
            >
              En savoir plus
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
